import { COMPONENT_NAME as TABS_COMPONENT_NAME, IMRTabsComponent } from './tabs/tabs.component'
import { COMPONENT_NAME as TAB_COMPONENT_NAME, IMRTabComponent } from './tab/tab.component'

export const TABS_MODULE_NAME = 'simax.common.tabs'

const module = angular.module(TABS_MODULE_NAME, [])

module.component(TABS_COMPONENT_NAME, new IMRTabsComponent())
module.component(TAB_COMPONENT_NAME, new IMRTabComponent())
